import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, NeutralColors, FontWeights, Stack, Text } from '@fluentui/react';

var classNames = mergeStyleSets({
    container: {
        height: 148,
        padding: 32,
        backgroundColor: NeutralColors.gray30
    },
    title: {
        fontWeight: FontWeights.semibold,
        color: NeutralColors.black
    },
    subTitle: {
        color: NeutralColors.gray160
    }
});
var MenuHeader = function(param) {
    var title = param.title, subTitle = param.subTitle, onRenderButtonsContent = param.onRenderButtonsContent;
    return /*#__PURE__*/ jsxs(Stack, {
        className: classNames.container,
        tokens: {
            childrenGap: 8
        },
        children: [
            /*#__PURE__*/ jsx(Text, {
                variant: "xxLarge",
                className: classNames.title,
                children: title
            }),
            /*#__PURE__*/ jsxs(Stack, {
                horizontal: true,
                horizontalAlign: "space-between",
                verticalAlign: "center",
                tokens: {
                    childrenGap: 32
                },
                children: [
                    /*#__PURE__*/ jsx(Stack.Item, {
                        grow: 1,
                        children: /*#__PURE__*/ jsx(Text, {
                            variant: "medium",
                            className: classNames.subTitle,
                            children: subTitle
                        })
                    }),
                    /*#__PURE__*/ jsx(Stack.Item, {
                        disableShrink: true,
                        children: onRenderButtonsContent === null || onRenderButtonsContent === void 0 ? void 0 : onRenderButtonsContent()
                    })
                ]
            })
        ]
    });
};

export { MenuHeader as default };
